<template>
  <div class="triggerBg">
    <loading :active.sync="isLoading" background-color="#D0D0D0">
      <div class="loadingio-spinner-eclipse-y24d302hfm">
        <div class="ldio-f9ujl5oazv5"></div>
      </div>
    </loading>
    <div v-if="show">
      <div id="navContainer">
        <div class="d-flex justify-content-between align-items-center mt-3">
          <div class="ml-2 ml-lg-5">
            <img src="https://www.chanchao.com.tw/images/logo.jpg" class="LogoStyle" height="65px" alt="" />
          </div>

          <div class="mr-2 mr-lg-5">
            <a href="https://www.chanchao.com.tw/ExhibitorServiceTW/Landing">
              <i class="fas fa-globe-asia mr-lg-1 mr-0 navTwText text-dark"></i>
              <span class="navTwText text-muted mr-lg-3 mr-1"> 中<span class="langStyle">文版</span></span>
            </a>
          </div>
        </div>
      </div>

      <div class="ml-5 mr-lg-0 mr-4">
        <p>&zwnj;</p>
        <p>&zwnj;</p>
        <div class="closeAllfont_3" style="margin-top: 110px">
          <div class="closeTopfont_3">
            <h1 style="letter-spacing: 1px">Welcome to the Exhibitor's Online Service System</h1>
          </div>
          <div class="mt-4">
            <p class="my-4" style="color: white">
              Log in with your Chan Chao membership account to proceed<br />to the Exhibitor's Online Service System.
            </p>
          </div>

          <div class="btn btn-light px-5 py-2 mt-3" style="border-radius: 30px; font-size: 18px" @click="Login">
            Login
          </div>

          <div class="mt-4" style="font-size: 16px; color: white">
            If you cannot log in or find your exhibition, please
            <a href="https://www.chanchao.com.tw/en/contact.asp" target="_blank"> contact us</a>.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import $ from 'jquery'

  export default {
    data() {
      return {
        access_token: '',
        show: false,
        isLoading: true,
      }
    },

    methods: {
      Login() {
        document.location.href = `https://www.chanchao.com.tw/accounts/en/login`
      },
    },

    mounted() {
      const vm = this
      vm.$store.dispatch('updateLoading', true)

      const url = 'https://www.chanchao.com.tw/apiLogin2/isAuthenticated'
      const info = null

      vm.$http.post(url, info).then(function (response) {
        if (response.data == 200) {
          sessionStorage.setItem('access', '200')
          document.location.href = 'https://www.chanchao.com.tw/ExhibitorServiceTW/en'
        } else {
          sessionStorage.setItem('access', '')
          sessionStorage.removeItem('access')
          $('.triggerBg').addClass('lobby_bg')

          vm.show = true
          vm.isLoading = false
        }
      })
    },
  }
</script>

<style lang="scss" scoped>
  #navContainer {
    width: 100%;
    height: 100px;
    background-color: rgb(255, 255, 255);
    position: fixed;
    top: 0;
    z-index: 99;
    color: #fff;
    font-size: 14px;
  }

  a:hover {
    color: #ffff00;
    text-decoration: underline;
  }

  a {
    color: #ffff00;
    text-decoration: underline;
  }

  #serial a {
    color: #ffffff;
  }

  #serial {
    width: 100%;
    position: absolute;
    left: 5%;
    top: 0;
    height: 40px;
    line-height: 40px;
    background-image: url(../../assets/images/favicon.png);
    background-repeat: no-repeat;
    background-size: 16px 16px;
    background-position: left center;
    padding-left: 20px;
  }

  @media screen and (max-width: 800px) {
    .LogoStyle {
      width: 300px;
    }
    .navTwText {
      font-size: 15px;
    }

    .langStyle {
      display: none;
    }

    #serial {
      top: 5px;
    }

    .viewHeight {
      padding-bottom: 600px;
    }

    .lobby_bg {
      background: url(../../assets/images/landing_bg_Mb.jpg);
      background-repeat: no-repeat;
      background-attachment: fixed;
      background-position: center;
      background-size: cover;
      width: 100%;
      height: 100vh;
    }

    .closeTopfont_3 {
      font-size: 30px;
      color: yellow;
      // font-style: italic;
    }

    .closeAllfont_3 {
      font-size: 20px;
      font-weight: bold;
    }
  }

  @media screen and (min-width: 801px) {
    .LogoStyle {
      width: 310px;
    }
    .navTwText {
      font-size: 17px;

      &:hover {
        color: rgb(34, 34, 34) !important;
      }
    }

    .langStyle {
      display: inline;
    }

    .viewHeight {
      padding-bottom: 35px;
    }

    .lobby_bg {
      background: url(../../assets/images/landing_bg.jpg);
      background-repeat: no-repeat;
      background-attachment: fixed;
      background-position: center;
      background-size: cover;
      width: 100%;
      height: 100vh;
    }

    .closeTopfont_3 {
      font-size: 45px;
      color: yellow;
      // font-style: italic;
    }

    .closeAllfont_3 {
      font-size: 26px;
      font-weight: bold;
    }
  }
</style>
